import {
  FormControl,
  FormControlLabel,
  FormControlLabelText,
  HStack,
  Input,
  InputField,
  Text,
} from "wealthmode-frontend/gluestack/ui"

/**
 * PercentField edits a rate as the percentage people quote. The text is kept
 * exactly as typed, so a half-entered value is never rewritten under the
 * cursor; blank means no rate.
 */
export function PercentField({
  label,
  value,
  onChange,
}: {
  label: string
  value: string
  onChange: (value: string) => void
}) {
  return (
    <FormControl>
      <FormControlLabel>
        <FormControlLabelText>{label}</FormControlLabelText>
      </FormControlLabel>
      <HStack className="gap-2 items-center">
        <Input
          variant="outline"
          className="w-32"
        >
          <InputField
            value={value}
            onChangeText={onChange}
            keyboardType="decimal-pad"
            autoCorrect={false}
          />
        </Input>
        <Text className="text-sm text-foreground-secondary">%</Text>
      </HStack>
    </FormControl>
  )
}
